import { render, staticRenderFns } from "./TableIncomeProduct.vue?vue&type=template&id=d029fc90"
import script from "./TableIncomeProduct.vue?vue&type=script&lang=js"
export * from "./TableIncomeProduct.vue?vue&type=script&lang=js"
import style0 from "./TableIncomeProduct.vue?vue&type=style&index=0&id=d029fc90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports